// Shared fleet helpers: fuzzy rate-sheet matching + body classification
export const words = (str) => (str || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(w => w.length > 3);

const DISTINCT_WORDS = ['bentayga','cullinan','urus','ghost','flying','spur','maybach','levante','sprinter','escalade','yukon','suburban','lincoln','hummer','bus','gls600','s580','s600','mulsanne','wagon','aventador','ferrari','corvette','taycan','tesla','r8'];

export const matchToRateSheet = (name, pricingVehicles) => {
  const mName = (name || '').toLowerCase();
  if (!mName) return null;
  for (const pv of pricingVehicles) {
    const pvName = (pv.vehicle_name || '').toLowerCase();
    const tokens = pvName.split(/[()·,\/]+/).map(s => s.trim()).filter(s => s.length > 3);
    for (const tok of tokens) {
      if (mName.includes(tok)) return pv;
    }
    const pvWords = words(pvName);
    const mWords = words(mName);
    if (pvWords.some(w => mWords.includes(w) && DISTINCT_WORDS.includes(w))) return pv;
  }
  return null;
};

export const classifyBody = (name = '') => {
  const n = name.toLowerCase();
  if (/sprinter|shuttle|mini.?bus|\bvan\b|\bbus\b/.test(n)) return 'van';
  if (/limo|stretch|hummer|lincoln stretch/.test(n)) return 'limo';
  if (/escalade|yukon|suburban|bentayga|cullinan|urus|g.?wagon|g550|g63|levante|gls|gle|range rover|dbx|\bxm\b|\bsuv\b/.test(n)) return 'suv';
  if (/corvette|ferrari|aventador|r8|\b911\b|porsche|amg gt|taycan|tesla|model\s?[sx3y]|m850|huracan|carrera|cybertruck/.test(n)) return 'sports';
  if (/sedan|s450|s550|s580|s600|s.?class|e350|e.?class|c300|ghost|maybach|flying spur|mulsanne|ct6|7 series|bmw 7/.test(n)) return 'sedan';
  return 'sedan';
};
